import { render } from "./SalesByProducts.vue?vue&type=template&id=aa7abe5c&scoped=true"
import script from "./SalesByProducts.vue?vue&type=script&lang=js"
export * from "./SalesByProducts.vue?vue&type=script&lang=js"

import "./SalesByProducts.vue?vue&type=style&index=0&id=aa7abe5c&lang=scss"
import "./SalesByProducts.vue?vue&type=style&index=1&id=aa7abe5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa7abe5c"]])

export default __exports__